'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('../node_modules/prop-types/index.js');
var clsx_m = require('../node_modules/clsx/dist/clsx.m.js');
var Checkbox = require('../Checkbox/Checkbox.js');
var HeaderCell = require('./HeaderCell.js');
var AutoSizeButton = require('./AutoSizeButton.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var HEADER_HEIGHT = 48;
var Header = /*#__PURE__*/React__namespace.memo(_ref => {
  var {
    columns,
    selected,
    selectionMode,
    toggleSelectionMode,
    autoSizeColumns,
    rowHeight,
    actionsWidth,
    isLoading
  } = _ref;

  if (isLoading) {
    return /*#__PURE__*/React__namespace.createElement("div", {
      className: clsx_m('GenjoDataTable__row', 'GenjoDataTable__header-row'),
      style: {
        height: rowHeight
      }
    });
  }

  return /*#__PURE__*/React__namespace.createElement("div", {
    className: clsx_m('GenjoDataTable__row', 'GenjoDataTable__header-row'),
    style: {
      height: rowHeight
    }
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: "GenjoDataTable__cell",
    style: {
      width: rowHeight,
      maxWidth: rowHeight,
      minWidth: rowHeight
    }
  }, /*#__PURE__*/React__namespace.createElement(Checkbox.Checkbox, {
    indeterminate: selected.size > 0,
    checked: selectionMode === 'exclude',
    onClick: toggleSelectionMode
  })), columns.map((column, index) => /*#__PURE__*/React__namespace.createElement(HeaderCell.HeaderCell, {
    index: index,
    key: column.dataKey,
    column: column
  })), actionsWidth > 0 && /*#__PURE__*/React__namespace.createElement("div", {
    className: "GenjoDataTable__actions",
    style: {
      width: actionsWidth,
      minWidth: actionsWidth,
      maxWdth: actionsWidth,
      height: HEADER_HEIGHT,
      textAlign: 'center'
    }
  }, /*#__PURE__*/React__namespace.createElement(AutoSizeButton.AutoSizeButton, {
    autoSizeColumns: autoSizeColumns
  })));
});
Header.displayName = 'Header';
Header.propTypes = {};

exports.Header = Header;
